module.exports = __webpack_public_path__ + "static/flags/BC-15edf390ed86451ade1033e44685670e.gif";